<template>
  <!--
    DrawingElementList
    -------------------------------------------------------------------------
    Lista das entidades adicionadas ao desenho (elementos + imagens) e a
    LEGENDA de acabamentos (itens type === "Acabamento" da ficha).
    Permite selecionar e remover. Não desenha nada; só navega/gerencia.
  -->
  <div class="std-list" :class="{ 'std-list--dark': isDark }">
    <!-- Legenda de acabamentos (itens da ficha, não bordas). Sem preço:
         o desenho técnico não menciona valores. -->
    <div v-if="finishingLegend.length" class="std-list-section">
      <div class="std-list-heading">
        <v-icon size="15" color="#555">mdi-brush-variant</v-icon>
        Acabamentos (ficha)
      </div>
      <div
        v-for="fin in finishingLegend"
        :key="fin.id"
        class="std-list-row std-list-row--legend"
      >
        <span class="std-list-name">{{ fin.quantity }}x {{ fin.label }}</span>
        <v-btn
          v-if="!readonly"
          icon
          x-small
          title="Remover este acabamento da ficha"
          @click.stop="$emit('remove', { kind: 'finishing', id: fin.sourceIndex })"
        >
          <v-icon size="16" color="grey">mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Elementos técnicos -->
    <div class="std-list-section">
      <div class="std-list-heading">
        <v-icon size="15" color="#555">mdi-shape-outline</v-icon>
        Elementos ({{ elements.length }})
      </div>
      <div v-if="!elements.length" class="std-list-empty">Nenhum elemento adicionado.</div>
      <div
        v-for="el in elements"
        :key="el.id"
        class="std-list-row"
        :class="{ active: isSelected('element', el.id) }"
        @click="$emit('select', { kind: 'element', id: el.id })"
      >
        <span class="std-list-name">{{ el.label }}</span>
        <v-btn icon x-small @click.stop="$emit('remove', { kind: 'element', id: el.id })">
          <v-icon size="16" color="grey">mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Imagens -->
    <div class="std-list-section">
      <div class="std-list-heading">
        <v-icon size="15" color="#555">mdi-image-multiple-outline</v-icon>
        Imagens ({{ images.length }})
      </div>
      <div v-if="!images.length" class="std-list-empty">Nenhuma imagem adicionada.</div>
      <div
        v-for="img in images"
        :key="img.id"
        class="std-list-row"
        :class="{ active: isSelected('image', img.id) }"
        @click="$emit('select', { kind: 'image', id: img.id })"
      >
        <span class="std-list-name">{{ img.label || 'Imagem' }}</span>
        <v-btn icon x-small @click.stop="$emit('remove', { kind: 'image', id: img.id })">
          <v-icon size="16" color="grey">mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DrawingElementList",
  props: {
    elements: { type: Array, default: () => [] },
    images: { type: Array, default: () => [] },
    finishingLegend: { type: Array, default: () => [] },
    selection: { type: Object, default: () => ({ kind: null, id: null }) },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    // condição oficial de tema escuro do sistema
    isDark() {
      return localStorage.dark === "true";
    }
  },
  methods: {
    isSelected(kind, id) {
      return this.selection && this.selection.kind === kind && this.selection.id === id;
    }
  }
};
</script>

<style scoped>
.std-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.std-list-heading {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #173b33;
  margin-bottom: 4px;
}
.std-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgba(7, 94, 84, 0.08);
  margin-bottom: 4px;
  cursor: pointer;
}
.std-list-row.active {
  border-color: #173b33;
  box-shadow: 0 0 0 1px rgba(23, 59, 51, 0.25);
}
.std-list-row--legend {
  cursor: default;
  background: #f3f8f5;
}
.std-list-name {
  font-size: 12px;
  color: #173b33;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.std-list-meta {
  font-size: 11px;
  font-weight: 700;
}
.std-list-empty {
  font-size: 11px;
  color: #9fb3ab;
  padding: 2px 4px;
}

/* ===== TEMA ESCURO (localStorage.dark === "true") ===== */
.std-list--dark .std-list-heading {
  color: #e9edef;
}
.std-list--dark .std-list-row {
  background: #182229;
  border-color: #26343c;
}
.std-list--dark .std-list-row--legend {
  background: #202c33;
}
.std-list--dark .std-list-row.active {
  border-color: #25d366;
  box-shadow: 0 0 0 1px rgba(37, 211, 102, 0.3);
}
.std-list--dark .std-list-name {
  color: #e9edef;
}
.std-list--dark .std-list-empty {
  color: #74838c;
}
</style>
